export function serialize(data: any) {
  return JSON.stringify(data, (_key, value) =>
    value === undefined ? '__undefined__' : value,
  );
}

export function deserialize(str: string) {
  return JSON.parse(str, (_key, value) =>
    value === '__undefined__' ? undefined : value,
  );
}
